import { Injectable } from '@angular/core';
import { AdPolicyService } from 'src/app/services/ad-policy/ad-policy.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';

@Injectable({ providedIn: 'root' })
export class SystemUpdatePresenterService {
	constructor(
		private deviceService: DeviceService,
		private featureToggleService: FeatureToggleService,
		private adPolicyService: AdPolicyService
	) {}

	isVisible(): boolean {
		return (
			this.adPolicyService.IsSystemUpdateEnabled &&
			this.featureToggleService.isPageAvailable('systemUpdate') &&
			!this.deviceService.isMMD
		);
	}
}
